{
  "actions": {
    "title": "Nuevos productos",
    "devices": "Nuevos equipos",
    "applications": "Nuevas aplicaciones"
  },
  "services": {
    "title": "Activación de los servicios",
    "activeDirectory": "Active Directory",
    "pkiConnector": "Conector PKI",
    "smtpServer": "Servidor SMTP",
    "unauthorized": "No hay ninguna información de activación de servicio disponible"
  },
  "sector": {
    "title": "Mis sectores",
    "devices": "Equipos",
    "applications": "Aplicaciones"
  },
  "certificates": {
    "valid": "Certificados válidos",
    "certificate": "certificados",
    "device": "Certificados S4",
    "manager": "Certificados S4-Manager",
    "tools": "Certificados S4-Tools",
    "view": "Certificados S4-View",
    "legend": {
      "valid": "válido",
      "expireSoon": "validez < 1 mes",
      "expired": "caducado"
    },
    "noData": "Sin datos",
    "title": "Estado del certificado",
    "expired": "Vencido",
    "lessThanOneMonth": "Menos de 1 mes",
    "lessThanThreeMonths": "Menos de 3 meses",
    "lessThanSixMonths": "Menos de 6 meses",
    "moreThanSixMonths": "Más de 6 meses"
  },
  "firmwares": {
    "noData": "No hay disponible ningún dato sobre la distribución de versiones de firmware",
    "others": "Otros",
    "title": "Distribución de la versión del firmware",
    "unknown": "Desconocido"
  },
  "deviceStates": {
    "title": "Estado del equipo",
    "states": {
      "activated": "Activado",
      "disabled": "Desactivado",
      "preprovisioned": "Preaprovisionado",
      "registered": "Registrado",
      "locked": "Bloqueado"
    }
  },
  "connectivity": {
    "title": "Estado de conectividad",
    "states": {
      "lessThan": "Menos de {duration}",
      "moreThan": "Más de {duration}",
      "unknown": "No se han realizado comprobaciones"
    },
    "noData": "Sin datos"
  }
}
